import { render, staticRenderFns } from "./TeamInvitation.vue?vue&type=template&id=9f3452c0&"
import script from "./TeamInvitation.vue?vue&type=script&lang=js&"
export * from "./TeamInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports